import jsCookie from "js-cookie"


const init = (V5Front: any) => {
  for (const key in V5Front) {
    if (V5Front[key].items?.itemsDict) return
    V5Front[key].items.itemsDict = {
        data: {},
        put: function (e: any, i: any) {
            this.data[e] = i
        },
        get: function (key: any) {
            try {
                return this.data[key]
            } catch (err) {
                return null
            }
        }
    }
    for (let i = 0, len = V5Front[key].items.length; i < len; i++) {
        V5Front[key].items.itemsDict.put(V5Front[key].items[i].key, V5Front[key].items[i])
    }
 }
 mergeError(V5Front)
}

  // 合并ErrorCode词条
  const mergeError = (V5Front: any) => {
    const reg = /.+[^G]ErrorCode$/g
    // 把项目级的error合并到V5Front.ResGErrorCode.items.itemsDict,直接调用它的put和get
    for(const item in V5Front) {
      const result = item.match(reg)
      if (result) {
        V5Front[item].items.forEach((dict: any) => {
          V5Front.ResGErrorCode.items.itemsDict.put(dict.key,dict)
        })
      }
    }
  }

export const useI18n = (V5Front: any) => {
  init(V5Front)
  return (_key: string, _defValue?: string) => {
    const arr = _key.split(".")
    // 获取V5Front
    let result: any = V5Front
    // console.log(result)
    //循环根据词条获取多语言的值
    const fnResult = () => {
      if (!result) return ''
      for (const item of arr) {
        result = result[item]
        if (!result) {
          return result
        }
      }
      return result
    }
    const val: any = fnResult()
    if (!val) {
      console.log(`${_key}词条不存在`)
    } 
    return val || _defValue || ''
  }
}

/**
 * @Date: 2022-10-26 10:07:35
 * @method: 设置语言
 * @param {string} lang 语言
 * @return {*}
 * @Author: wzt
 */
export const setLang = (lang: string) => {
  const KEY = 'v5_Culture'
  // console.log(lang, jsCookie.get(KEY), '1111')
  // 重置v5_Culture
  if (lang !== jsCookie.get(KEY)) {
    jsCookie.remove(KEY, { domain: 'm.17track.net', path: '/' })
		jsCookie.remove(KEY, { domain: 't.17track.net', path: '/' })
		jsCookie.remove(KEY, { domain: 'extcall.17track.net', path: '/' })
		jsCookie.remove(KEY, { path: '/' })
		jsCookie.remove(KEY)
		jsCookie.set(KEY, lang, { domain: '17track.net', expires: 365, path: '/' })
    // TODO 。。。请求接口.....
  }
}
